import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const propelInit = function() {
const sliders = document.querySelectorAll(
	'.block-media-carousel-grid .swiper:not(.swiper-initialized)'
);

sliders.forEach((slider) => {
	const parentBlock = slider.closest('.acf-block');
	const slides = slider.querySelectorAll('.wp-block-image');
	const mobileGap = parentBlock?.dataset?.mobileSliderGap ?? 12;
	const desktopGap = parentBlock?.dataset?.desktopSliderGap ?? 12;

	const settings = {
		loop: slides.length > 1 ? true : false,
		grabCursor: true,
		spaceBetween: mobileGap,
		slidesPerView: 1,
		modules: [A11y, Navigation],
		slideClass: 'wp-block-image',
		a11y: {
			itemRoleDescriptionMessage: 'slide',
		},
		navigation: {
			prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
			nextEl: slider.parentElement.querySelector('.swiper-button-next'),
		},
		breakpoints: {
			768: {
				spaceBetween: desktopGap,
			},
		},
	};

	// Deferred two to avoid forced reflow. Make sure CSS makes the block appear the same before and after swiper initializes, to avoid CLS.
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			new Swiper(slider, settings);
		});
	});
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['media-carousel-grid'] = window.propel.blocks['media-carousel-grid'] || {};
window.propel.blocks['media-carousel-grid'].script = propelInit;
